import React from "react";

import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";

import RbFlexTableContext from "./RbFlexTableContext";

const RbFlexTable = React.forwardRef(function RbFlexTable(props, ref) {
  const {
    children,
    expandable,
    hoverable,
    id,
    selectable,
    variant,
    ...other
  } = props;

  const contextValue = React.useMemo(() => {
    return {
      expandable,
      hoverable,
      id,
      selectable,
      variant,
    };
  }, [expandable, hoverable, id, selectable, variant]);

  return (
    <RbFlexTableContext.Provider value={contextValue}>
      <Box role="table" {...other} id={id} ref={ref}>
        {children}
      </Box>
    </RbFlexTableContext.Provider>
  );
});

RbFlexTable.propTypes = {
  children: PropTypes.node,
  expandable: PropTypes.bool,
  hoverable: PropTypes.bool,
  id: PropTypes.string,
  selectable: PropTypes.bool,
  variant: PropTypes.oneOf(["default", "striped", "card"]),
};

RbFlexTable.defaultProps = {
  children: null,
  expandable: false,
  hoverable: false,
  id: undefined,
  selectable: false,
  variant: "default",
};

export default React.memo(RbFlexTable);
